import { useState } from 'react'
import { CommentsProps } from './types'
import { useCheckPermissions } from 'hooks/useCheckPermission'
import { Button, Descriptions, Space, Spin } from 'antd'
import { alphabeticalSort } from 'shared'
import CIMSComment from 'components/CIMSComment'
import { dateFormatter } from '../../../../../../../../../utils/dateFormatter'

function Comments<T>({
  comments,
  onSave,
  permission,
  record,
  loading: loadingProp,
}: CommentsProps<T>) {
  const [loading, setLoading] = useState(false)
  const [addingComment, setAddingComment] = useState(false)
  const flip = () => setAddingComment((prev) => !prev)
  const [comment, setComment] = useState<string>()
  const cleanUp = () => {
    flip()
    setComment(undefined)
    setLoading(false)
  }
  const can = useCheckPermissions<T>(record)
  return (
    <Spin spinning={loadingProp ?? false}>
      {comments.length > 0 && (
        <Descriptions title="Comments" size="small" column={1}>
          {comments
            .sort(alphabeticalSort('createdDate'))
            .map(({ createdDate, text, user: { mail } }, i) => (
              <Descriptions.Item
                key={`${i}-${text}-${createdDate}-${mail}`}
                label={
                  <>
                    [{dateFormatter.shortDatetime(createdDate)}]&nbsp;{mail}
                  </>
                }
              >
                {text}
              </Descriptions.Item>
            ))}
        </Descriptions>
      )}
      {can(permission) && (
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          {addingComment && (
            <CIMSComment
              showLabel
              onChange={({ target: { value } }) => setComment(value)}
            />
          )}
          <Space direction="horizontal" size="middle">
            <Button
              onClick={() => {
                if (addingComment || comment?.length === 0) flip()
                else cleanUp()
              }}
            >
              {addingComment ? 'Cancel' : 'Add Comment'}
            </Button>
            {addingComment && (
              <Button
                type="primary"
                loading={loading}
                disabled={comment?.length === 0}
                onClick={async () => {
                  setLoading(true)
                  if (comment) await onSave(comment)
                  cleanUp()
                }}
              >
                Save
              </Button>
            )}
          </Space>
        </Space>
      )}
    </Spin>
  )
}

export default Comments
